import { provideAppInitializer, ApplicationConfig, inject, importProvidersFrom, LOCALE_ID, ErrorHandler } from '@angular/core';
import { provideRouter, RouteReuseStrategy, PreloadAllModules, withPreloading } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient } from "@angular/common/http";
import { provideServiceWorker } from '@angular/service-worker';

import { registerLocaleData } from "@angular/common";
import localeFrBe from "@angular/common/locales/fr-BE";
import localeFr from '@angular/common/locales/fr';

import { IntlModule } from "@progress/kendo-angular-intl";
import { provideQuillConfig } from "ngx-quill";

import { PosthogService } from './services/posthog.service';
import { providePostHogErrorHandler } from './posthog-error-handler';

import { AmplifyAuthSubscriptionService } from './services/amplify-auth-subscription.service';
import { UpdateService } from "./services/update.service";
import { UserGroupService } from './services/user-group.service';

import { routes } from './app.routes';
import { environment } from 'src/environments/environment';

// Register locale data
registerLocaleData(localeFrBe);
registerLocaleData(localeFr, 'fr-FR');



export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(),
    provideIonicAngular(),
    provideAnimationsAsync(),
    importProvidersFrom(
      IntlModule
    ),
    provideQuillConfig({
      theme: "snow",
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, false] }],
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ align: [] }],
          ["link"],
          ["clean"],
        ],
      },
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.domain !== "localhost:8100",
      registrationStrategy: "registerImmediately",
    }),
    UpdateService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LOCALE_ID, useValue: "fr-BE" },
    provideAppInitializer(() => {
      const posthog = inject(PosthogService);
      return posthog.initializeForUser();
    }),
    providePostHogErrorHandler(),
    provideAppInitializer(() => {
      const amplifyAuthSubscriptionService = inject(AmplifyAuthSubscriptionService);
      return amplifyAuthSubscriptionService.initializeSubscription();
    }),
    provideAppInitializer(() => {
      const userGroupService = inject(UserGroupService);
    })
  ]
};
